import React, { useEffect, useRef } from 'react';
import './StoreModal.css';

const AppleLogo = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
  </svg>
);

const GooglePlayLogo = () => (
  <svg width="26" height="26" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <linearGradient id="gp1" x1="3.761" y1="23.999" x2="44.238" y2="23.999" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#039ae5"/>
      <stop offset="0.5" stopColor="#00b8ff"/>
    </linearGradient>
    <path fill="url(#gp1)" d="M44.238 22.97L9.128 3.28A1.373 1.373 0 0 0 7.4 3.41L33.6 24l10.638-1.03z"/>
    <linearGradient id="gp2" x1="19.595" y1="34.099" x2="38.405" y2="14.902" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#e02452"/>
      <stop offset="0.5" stopColor="#ff5574"/>
    </linearGradient>
    <path fill="url(#gp2)" d="M44.238 25.03L33.6 24 7.4 44.59a1.373 1.373 0 0 0 1.728.13l35.11-19.69z"/>
    <linearGradient id="gp3" x1="3.553" y1="24" x2="24.711" y2="24" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#38b33b"/>
      <stop offset="0.5" stopColor="#4fd44f"/>
    </linearGradient>
    <path fill="url(#gp3)" d="M7.4 3.41A1.36 1.36 0 0 0 3.553 4.61v38.78a1.36 1.36 0 0 0 3.847 1.2L33.6 24 7.4 3.41z"/>
    <linearGradient id="gp4" x1="9.191" y1="24" x2="44.238" y2="24" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#ffd843"/>
      <stop offset="0.5" stopColor="#ffed00"/>
    </linearGradient>
    <path fill="url(#gp4)" d="M44.238 22.97L33.6 24 7.4 3.41a1.373 1.373 0 0 1 1.728.13l35.11 19.43z"/>
  </svg>
);

export default function StoreModal({ onClose }) {
  const modalRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) onClose();
    };
    document.addEventListener('mousedown', handler);
    const escHandler = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', escHandler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('keydown', escHandler);
    };
  }, [onClose]);

  return (
    <div className="store-overlay">
      <div className="store-modal" ref={modalRef}>
        <button className="store-modal-close" onClick={onClose} aria-label="Close">✕</button>
        <div className="store-modal-header">
          <div className="store-modal-app-icon">AX</div>
          <h3>Download AfreXpert</h3>
          <p>Select your preferred platform</p>
        </div>
        <div className="store-buttons">
          <a
            href="https://apps.apple.com"
            target="_blank"
            rel="noopener noreferrer"
            className="store-btn apple"
            onClick={onClose}
          >
            <div className="store-btn-logo"><AppleLogo /></div>
            <div className="store-btn-text">
              <small>Download on the</small>
              <strong>App Store</strong>
            </div>
          </a>
          <a
            href="https://play.google.com"
            target="_blank"
            rel="noopener noreferrer"
            className="store-btn google"
            onClick={onClose}
          >
            <div className="store-btn-logo"><GooglePlayLogo /></div>
            <div className="store-btn-text">
              <small>Get it on</small>
              <strong>Google Play</strong>
            </div>
          </a>
        </div>
        <p className="store-modal-footer">Free to download · Available worldwide</p>
      </div>
    </div>
  );
}
